// ---------------------------------------------------------------------------
// MobileNavDrawer — the sidebar on a phone (AL-1972)
// ---------------------------------------------------------------------------
// Below `sm` the 72px rail took a fifth of the screen. The full sidebar, the
// same one as on desktop, opens here from the topbar's menu button instead.
// A Radix dialog underneath: focus stays inside, Escape and the overlay close
// it, and the page behind is inert while it is open.
// ---------------------------------------------------------------------------

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sheet, SheetContent, SheetTitle } from '@/components/ui/sheet';
import { ShellSidebar, type ShellSidebarProps } from './ShellSidebar';
import { SIDEBAR_WIDTH_PX } from './constants';

export interface MobileNavDrawerProps {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly sidebar: Pick<ShellSidebarProps, 'items' | 'pathname' | 'getNavTo'>;
}

export const MobileNavDrawer: React.FC<MobileNavDrawerProps> = ({
  open,
  onOpenChange,
  sidebar,
}) => {
  const { t } = useTranslation();

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="left"
        hideCloseButton
        aria-describedby={undefined}
        style={{ width: SIDEBAR_WIDTH_PX }}
        className="max-w-[85vw] border-v11-border bg-v11-sidebar-bg p-0 sm:max-w-none"
      >
        <SheetTitle className="sr-only">{t('app.v11.shell.mobileNav.title')}</SheetTitle>
        <ShellSidebar
          {...sidebar}
          collapsed={false}
          onToggleCollapsed={() => undefined}
          canToggle={false}
          inDrawer
        />
      </SheetContent>
    </Sheet>
  );
};
